import { useEffect } from 'react';

/** Imposta il titolo del tab browser. Resta auto-resettato al default di index.html al umount. */
export function usePageTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} - VVF Tracker` : 'VVF Tracker';
    return () => { document.title = previous; };
  }, [title]);
}
